module.exports = __webpack_public_path__ + "static/media/txnSuccess.3e6de2ce.svg";